import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Acordeão nativo (details/summary): o conteúdo fica no HTML e funciona
 * sem JavaScript. `name` agrupa itens para abrir um de cada vez.
 */
export function Disclosure({
  summary,
  children,
  name,
  className,
  summaryClassName,
  contentClassName,
}: {
  summary: ReactNode;
  children: ReactNode;
  name?: string;
  className?: string;
  summaryClassName?: string;
  contentClassName?: string;
}) {
  return (
    <details name={name} className={cn("disclosure border-b", className)}>
      <summary
        className={cn(
          "flex flex-1 cursor-pointer items-center justify-between py-4 text-left text-sm font-medium transition-all hover:underline",
          summaryClassName,
        )}
      >
        {summary}
        <ChevronDown
          aria-hidden="true"
          className="disclosure-chevron ml-2 h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200"
        />
      </summary>
      <div className="overflow-hidden text-sm">
        <div className={cn("pb-4 pt-0", contentClassName)}>{children}</div>
      </div>
    </details>
  );
}
